import React from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "@piiqtechnologies/svg-icons";
import { PeekButton, PeekStack, PeekTypography, useTheme } from "@piiqtechnologies/ui-components";
export const AppHeader = ({ icon, headerLabel, headerDesc, backButton, onBackButtonClick, }) => {
    const theme = useTheme();
    const navigate = useNavigate();
    const OnBack = () => {
        if (!onBackButtonClick) {
            navigate(-1);
        }
        else {
            onBackButtonClick();
        }
    };
    return (React.createElement(PeekStack, { spacing: 1 },
        backButton ? (React.createElement(PeekButton, { startIcon: React.createElement(ChevronLeft, null), onClick: OnBack, sx: {
                boxShadow: "none",
                ":hover": { background: "transparent", color: "secondary.main", "> svg": "secondary.main" },
            } },
            React.createElement(PeekStack, { direction: "row", spacing: theme.spacing(1), alignItems: "center", justifyContent: "center" }, icon !== null && icon !== void 0 ? icon : "",
                React.createElement(PeekTypography, { variant: "h2", whiteSpace: "nowrap", fontWeight: theme.typography.fontWeightLight }, headerLabel)))) : (React.createElement(PeekStack, { direction: "row", spacing: theme.spacing(1), alignItems: "center", justifyContent: "center" }, icon !== null && icon !== void 0 ? icon : "",
            React.createElement(PeekTypography, { variant: "h2", whiteSpace: "nowrap", fontWeight: theme.typography.fontWeightLight }, headerLabel))),
        headerDesc && (React.createElement(PeekTypography, { variant: "h4", whiteSpace: "nowrap" }, headerDesc))));
};
export default AppHeader;
